import { Box, LinearProgress, Tooltip, Typography } from "@mui/material";
import { useInitiativeProgressUpdates } from "../hooks/useInitiativeProgressUpdates";

export default function ProgressBar({ initiative }) {
  const { progressUpdates } = useInitiativeProgressUpdates(initiative);
  const progress = initiative?.progress ?? 0;
  const markers = progressUpdates
    .filter((update) => update.message)
    .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt));

  const styles = {
    row: { display: "flex", alignItems: "center", gap: 1 },
    trackWrap: { position: "relative", flexGrow: 1 },
    track: {
      height: 8,
      borderRadius: 4,
      bgcolor: "background.progressTrack",
    },
    marker: (leftPercent) => ({
      position: "absolute",
      top: -3,
      left: `${leftPercent}%`,
      width: 3,
      height: 14,
      borderRadius: 1,
      bgcolor: "background.text",
      transform: "translateX(-50%)",
      cursor: "pointer",
    }),
    tooltipValue: { fontWeight: 700, display: "block" },
  };

  return (
    <Box sx={styles.row}>
      <Box sx={styles.trackWrap}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={styles.track}
        />
        {markers.map((update) => (
          <Tooltip
            key={update.id}
            title={
              <>
                <Typography variant="caption" sx={styles.tooltipValue}>
                  {update.newValue}%
                </Typography>
                {update.message}
              </>
            }
            arrow
          >
            <Box sx={styles.marker(update.newValue)} />
          </Tooltip>
        ))}
      </Box>
      <Typography variant="body2">{progress}%</Typography>
    </Box>
  );
}
